import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b4d845e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-header__h1" }
const _hoisted_2 = { class: "content-header__h2" }
const _hoisted_3 = { class: "content-header__h3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pseudo-borders" }, null, -1))

import { Pages } from '@/views/pages/usePages';
import { animationState } from '@/services/animation-service/animation-state.ts';

export default /*#__PURE__*/_defineComponent({
  __name: 'content-header',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.name)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'content-header-wrapper',
        _unref(animationState).flow
    ])
        }, [
          _createVNode(_Transition, {
            name: "top-to-down content-header-transition",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("header", {
                key: _unref(Pages)[_ctx.$route.name.toString()].contentHeaderData.h1,
                class: "content-header"
              }, [
                _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(Pages)[_ctx.$route.name.toString()].contentHeaderData.h1), 1),
                _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(Pages)[_ctx.$route.name.toString()].contentHeaderData.h2), 1),
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(Pages)[_ctx.$route.name.toString()].contentHeaderData.h3), 1)
              ]))
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "content-header-background-transition" }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", {
                class: "content-header-background",
                key: 
                    _unref(Pages)[
                        _ctx.$route.name.toString()
                    ].contentHeaderData.backgroundImageUrl.toString()
                
              }, [
                _createElementVNode("img", {
                  class: "content-header-background__img",
                  src: 
                        _unref(Pages)[
                            _ctx.$route.name.toString()
                        ].contentHeaderData.backgroundImageUrl.toString()
                    ,
                  style: _normalizeStyle(`object-position: center ${
                        _unref(Pages)[_ctx.$route.name.toString()].contentHeaderData
                            .backgroundImageShift
                    }%;`)
                }, null, 12, _hoisted_4),
                _createElementVNode("img", {
                  class: "content-header-background__img content-header-background__img--dark",
                  src: 
                        _unref(Pages)[_ctx.$route.name.toString()].contentHeaderData
                            .backgroundImageDarkUrl
                            ? _unref(Pages)[
                                  _ctx.$route.name.toString()
                              ].contentHeaderData.backgroundImageDarkUrl?.toString()
                            : _unref(Pages)[
                                  _ctx.$route.name.toString()
                              ].contentHeaderData.backgroundImageUrl.toString()
                    ,
                  style: _normalizeStyle(`object-position: center ${
                        _unref(Pages)[_ctx.$route.name.toString()].contentHeaderData
                            .backgroundImageShift
                    }%;`)
                }, null, 12, _hoisted_5)
              ]))
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    _hoisted_6
  ], 64))
}
}

})